import { Component, Input, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { Threat } from '../../../../models/threat';
import { Question } from '../../../../models/question';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalComponent } from '../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddEditThreatComponent } from '../../modals/add-edit-threat/add-edit-threat.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CopyThreatsFromTemplateComponent } from '../../modals/copy-threats-from-template/copy-threats-from-template.component';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-template-threats',
  templateUrl: './risk-template-threats.component.html',
  styleUrls: ['./risk-template-threats.component.scss']
})
export class RiskTemplateThreatsComponent implements OnInit {
  @Input() riskTemplateId: string;
  threats: Array<Threat> = [];
  questions: Array<Question> = [];
  params = {

    withQuestions: true,
  };
  loading: boolean;
  rowGroupMetadata: any;
  confirmationDynamicDialogRef: DynamicDialogRef;

  constructor(private riskService: AgilityRiskService,
              private dialogService: DialogService,
              private messageService: AgilityRiskMessageService,
              private translateService: TranslateService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.riskTemplateId = this.riskTemplateId ? this.riskTemplateId : '11';
  }

  ngOnInit(): void {
    this.loading = true;
    this.getThreats();
  }

  getThreats() {
    this.loading = true;
    this.threats = [];
    this.riskService.getThreats(this.riskTemplateId, this.params).subscribe((result: Array<Threat>) => {
      this.threats = result;
      this.updateRowGroupMetaData();
      this.loading = false;
    });
  }


  deleteThreat(threatId: string): void {
    this.confirmationDynamicDialogRef = this.dialogService.open(ConfirmationModalComponent, {
      data: {
        body: this.translateService.instant('riskTemplates.threat.deleteThreatBody')
      },
      header: this.translateService.instant('riskTemplates.threat.deleteThreat'),
      width: '35%'
    });

    this.confirmationDynamicDialogRef.onClose.subscribe((result: any) => {
      if (result) {
        this.riskService.deleteThreat(threatId).subscribe({
          next: (response) => {
            this.threats = this.threats.filter(threat => threat.id !== threatId);
            this.messageService.success(this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.threat.threatDeleteSuccessfully'));

          },
          error: (err) => {
            this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.threat.threatDeleteUnSuccessfully'));
          }
        });
      }
    });
  }

  updateRowGroupMetaData(threats?: Array<Threat>) {
    const threatList = threats ? threats : this.threats;
    this.rowGroupMetadata = {};

    if (this.threats) {
      for (let i = 0; i < threatList.length; i++) {
        const rowData = threatList[i];
        const threatId = rowData.id;

        if (i == 0) {
          this.rowGroupMetadata[threatId] = {index: 0, size: 1};
        } else {
          const previousRowData = threatList[i - 1];
          const previousRowGroup = previousRowData.id;
          if (threatId === previousRowGroup) {
            this.rowGroupMetadata[threatId].size++;
          } else {
            this.rowGroupMetadata[threatId] = {index: i, size: 1};
          }
        }
      }
    }
  }


  customSort(event) {
    this.threats.sort((a, b) => {
      const aGroup = _.get(a, event.field)?.toLowerCase();
      const bGroup = _.get(b, event.field)?.toLowerCase();
      if (event.order == 1) {
        return (aGroup < bGroup) ? -1 : (aGroup > bGroup) ? 1 : 0;
      } else {
        return (aGroup < bGroup) ? 1 : (aGroup > bGroup) ? -1 : 0;

      }
    });
    return 0;
  }

  sort(event) {
    this.updateRowGroupMetaData(event.filteredValue);
  }

  addEditThreat(threat?: Threat) {
    const ref = this.dialogService.open(AddEditThreatComponent, {
      data: {
        threatData: threat,
        riskTemplateId: this.riskTemplateId
      },
      header: threat ? this.translateService.instant('riskTemplates.addEditThreat.editThreat') : this.translateService.instant('riskTemplates.addEditThreat.addNewThreat'),
      width: '70%',
    });
    ref.onClose.subscribe(isSaving => isSaving ? this.getThreats() : '');
  }

  goToThreatQuestions(threatId: string) {
    this.router.navigate([`risk-template/${this.riskTemplateId}/threat/${threatId}/questions`], {relativeTo: this.activatedRoute.parent});
  }

  copyThreats() {
    const dlgRef = this.dialogService.open(CopyThreatsFromTemplateComponent, {
      header: this.translateService.instant(this.translateService.instant('riskTemplates.addThreatsFromAnotherTemplate')),
      width: '50%',
      data: {
        destinationTemplateId: this.riskTemplateId
      }
    });
    dlgRef.onClose.subscribe(result => result ? this.getThreats() : '');
  }
}
